import { render, staticRenderFns } from "./form-photo.vue?vue&type=template&id=17c0a68b&"
import script from "./form-photo.vue?vue&type=script&lang=js&"
export * from "./form-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports